/**
 * Canonical PostHog experiment / multivariate flag keys (kebab-case).
 *
 * Convention for new experiments: `{domain}-{surface}-{hypothesis}` in kebab-case.
 * Variant values in app code: kebab-case strings; `control` is always baseline.
 * (PostHog payloads may use underscores — normalize at the callsite if needed.)
 */
export const EXPERIMENTS = {
  COOKIE_CONSENT_VARIANT: 'cookie-consent-variant',
} as const;

export type ExperimentKey = (typeof EXPERIMENTS)[keyof typeof EXPERIMENTS];
